module.exports = __webpack_public_path__ + "img/01.d7ccc417.png";